/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  GetAiTranslationUsageParams,
  PostAiTranslateAllProductsBody,
  PostAiTranslateBatchBody,
  PostAiTranslateBody,
  TranslateStatus,
  TranslatedText,
  TranslatedToAll,
  TranslationJobStarted,
  TranslationJobStatus,
  TranslationUsage,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPostAiTranslateUrl = () => {
  return `/api/v1/ai/translate`
}

/**
 * @summary Translate one string
 */
export const postAiTranslate = async (
  postAiTranslateBody?: PostAiTranslateBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslatedText> => {
  return customFetch<TranslatedText>(getPostAiTranslateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAiTranslateBody),
  })
}

export const getPostAiTranslateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiTranslate>>,
    TError,
    { data?: PostAiTranslateBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiTranslate>>,
  TError,
  { data?: PostAiTranslateBody },
  TContext
> => {
  const mutationKey = ['postAiTranslate']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiTranslate>>,
    { data?: PostAiTranslateBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAiTranslate(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAiTranslateMutationResult = NonNullable<Awaited<ReturnType<typeof postAiTranslate>>>
export type PostAiTranslateMutationBody = PostAiTranslateBody | undefined
export type PostAiTranslateMutationError = unknown

/**
 * @summary Translate one string
 */
export const usePostAiTranslate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiTranslate>>,
      TError,
      { data?: PostAiTranslateBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiTranslate>>,
  TError,
  { data?: PostAiTranslateBody },
  TContext
> => {
  return useMutation(getPostAiTranslateMutationOptions(options), queryClient)
}
export const getPostAiTranslateCategoriesUrl = () => {
  return `/api/v1/ai/translate-categories`
}

/**
 * @summary Translate every category, in the background
 */
export const postAiTranslateCategories = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationJobStarted> => {
  return customFetch<TranslationJobStarted>(getPostAiTranslateCategoriesUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostAiTranslateCategoriesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiTranslateCategories>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiTranslateCategories>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postAiTranslateCategories']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiTranslateCategories>>,
    void
  > = () => {
    return postAiTranslateCategories(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAiTranslateCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiTranslateCategories>>
>

export type PostAiTranslateCategoriesMutationError = unknown

/**
 * @summary Translate every category, in the background
 */
export const usePostAiTranslateCategories = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiTranslateCategories>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiTranslateCategories>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostAiTranslateCategoriesMutationOptions(options), queryClient)
}
export const getPostAiTranslateBatchUrl = () => {
  return `/api/v1/ai/translate-batch`
}

/**
 * @summary Translate one string into every configured language
 */
export const postAiTranslateBatch = async (
  postAiTranslateBatchBody?: PostAiTranslateBatchBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslatedToAll> => {
  return customFetch<TranslatedToAll>(getPostAiTranslateBatchUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAiTranslateBatchBody),
  })
}

export const getPostAiTranslateBatchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiTranslateBatch>>,
    TError,
    { data?: PostAiTranslateBatchBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiTranslateBatch>>,
  TError,
  { data?: PostAiTranslateBatchBody },
  TContext
> => {
  const mutationKey = ['postAiTranslateBatch']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiTranslateBatch>>,
    { data?: PostAiTranslateBatchBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAiTranslateBatch(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAiTranslateBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiTranslateBatch>>
>
export type PostAiTranslateBatchMutationBody = PostAiTranslateBatchBody | undefined
export type PostAiTranslateBatchMutationError = unknown

/**
 * @summary Translate one string into every configured language
 */
export const usePostAiTranslateBatch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiTranslateBatch>>,
      TError,
      { data?: PostAiTranslateBatchBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiTranslateBatch>>,
  TError,
  { data?: PostAiTranslateBatchBody },
  TContext
> => {
  return useMutation(getPostAiTranslateBatchMutationOptions(options), queryClient)
}
export const getPostAiTranslateAllProductsUrl = () => {
  return `/api/v1/ai/translate-all-products`
}

/**
 * @summary Translate every product, in the background
 */
export const postAiTranslateAllProducts = async (
  postAiTranslateAllProductsBody?: PostAiTranslateAllProductsBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationJobStarted> => {
  return customFetch<TranslationJobStarted>(getPostAiTranslateAllProductsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postAiTranslateAllProductsBody),
  })
}

export const getPostAiTranslateAllProductsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAiTranslateAllProducts>>,
    TError,
    { data?: PostAiTranslateAllProductsBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAiTranslateAllProducts>>,
  TError,
  { data?: PostAiTranslateAllProductsBody },
  TContext
> => {
  const mutationKey = ['postAiTranslateAllProducts']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAiTranslateAllProducts>>,
    { data?: PostAiTranslateAllProductsBody }
  > = (props) => {
    const { data } = props ?? {}

    return postAiTranslateAllProducts(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostAiTranslateAllProductsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAiTranslateAllProducts>>
>
export type PostAiTranslateAllProductsMutationBody = PostAiTranslateAllProductsBody | undefined
export type PostAiTranslateAllProductsMutationError = unknown

/**
 * @summary Translate every product, in the background
 */
export const usePostAiTranslateAllProducts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAiTranslateAllProducts>>,
      TError,
      { data?: PostAiTranslateAllProductsBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAiTranslateAllProducts>>,
  TError,
  { data?: PostAiTranslateAllProductsBody },
  TContext
> => {
  return useMutation(getPostAiTranslateAllProductsMutationOptions(options), queryClient)
}
export const getGetAiTranslationUsageUrl = (params?: GetAiTranslationUsageParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/ai/translation-usage?${stringifiedParams}`
    : `/api/v1/ai/translation-usage`
}

/**
 * @summary What the translations have cost
 */
export const getAiTranslationUsage = async (
  params?: GetAiTranslationUsageParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationUsage> => {
  return customFetch<TranslationUsage>(getGetAiTranslationUsageUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetAiTranslationUsageQueryKey = (params?: GetAiTranslationUsageParams) => {
  return [`/api/v1/ai/translation-usage`, ...(params ? [params] : [])] as const
}

export const getGetAiTranslationUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiTranslationUsage>>,
  TError = unknown,
>(
  params?: GetAiTranslationUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslationUsage>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAiTranslationUsageQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiTranslationUsage>>> = ({ signal }) =>
    getAiTranslationUsage(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiTranslationUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiTranslationUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiTranslationUsage>>
>
export type GetAiTranslationUsageQueryError = unknown

export function useGetAiTranslationUsage<
  TData = Awaited<ReturnType<typeof getAiTranslationUsage>>,
  TError = unknown,
>(
  params: undefined | GetAiTranslationUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslationUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslationUsage>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslationUsage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslationUsage<
  TData = Awaited<ReturnType<typeof getAiTranslationUsage>>,
  TError = unknown,
>(
  params?: GetAiTranslationUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslationUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslationUsage>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslationUsage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslationUsage<
  TData = Awaited<ReturnType<typeof getAiTranslationUsage>>,
  TError = unknown,
>(
  params?: GetAiTranslationUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslationUsage>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the translations have cost
 */

export function useGetAiTranslationUsage<
  TData = Awaited<ReturnType<typeof getAiTranslationUsage>>,
  TError = unknown,
>(
  params?: GetAiTranslationUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslationUsage>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAiTranslationUsageQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAiTranslateStatusUrl = () => {
  return `/api/v1/ai/translate-status`
}

/**
 * @summary Whether translation is configured, and into what
 */
export const getAiTranslateStatus = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslateStatus> => {
  return customFetch<TranslateStatus>(getGetAiTranslateStatusUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetAiTranslateStatusQueryKey = () => {
  return [`/api/v1/ai/translate-status`] as const
}

export const getGetAiTranslateStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiTranslateStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateStatus>>, TError, TData>>
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAiTranslateStatusQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiTranslateStatus>>> = ({ signal }) =>
    getAiTranslateStatus({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiTranslateStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAiTranslateStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiTranslateStatus>>
>
export type GetAiTranslateStatusQueryError = unknown

export function useGetAiTranslateStatus<
  TData = Awaited<ReturnType<typeof getAiTranslateStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslateStatus>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslateStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslateStatus<
  TData = Awaited<ReturnType<typeof getAiTranslateStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslateStatus>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslateStatus>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslateStatus<
  TData = Awaited<ReturnType<typeof getAiTranslateStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether translation is configured, and into what
 */

export function useGetAiTranslateStatus<
  TData = Awaited<ReturnType<typeof getAiTranslateStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateStatus>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAiTranslateStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetAiTranslateJobIdUrl = (id: string) => {
  return `/api/v1/ai/translate-job/${id}`
}

/**
 * @summary How a bulk translation is getting on
 */
export const getAiTranslateJobId = async (
  id: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<TranslationJobStatus> => {
  return customFetch<TranslationJobStatus>(getGetAiTranslateJobIdUrl(id), {
    ...options,
    method: 'GET',
  })
}

export const getGetAiTranslateJobIdQueryKey = (id: string) => {
  return [`/api/v1/ai/translate-job/${id}`] as const
}

export const getGetAiTranslateJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiTranslateJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetAiTranslateJobIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiTranslateJobId>>> = ({ signal }) =>
    getAiTranslateJobId(id, { signal, ...requestOptions })

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }
}

export type GetAiTranslateJobIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiTranslateJobId>>
>
export type GetAiTranslateJobIdQueryError = unknown

export function useGetAiTranslateJobId<
  TData = Awaited<ReturnType<typeof getAiTranslateJobId>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslateJobId>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslateJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslateJobId<
  TData = Awaited<ReturnType<typeof getAiTranslateJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiTranslateJobId>>,
          TError,
          Awaited<ReturnType<typeof getAiTranslateJobId>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAiTranslateJobId<
  TData = Awaited<ReturnType<typeof getAiTranslateJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How a bulk translation is getting on
 */

export function useGetAiTranslateJobId<
  TData = Awaited<ReturnType<typeof getAiTranslateJobId>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiTranslateJobId>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAiTranslateJobIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
